import { Column, TableCollectionTemplate } from "./table.model";

// TODO: Move this to a more generic place for all columns
export const nameColumn: Column = {
	id: 'name',
	name: $localize `:Table Name Column Label@@tableColumnNameLabel:Name`,
	path: 'name',
	type: 'field',
	width: 300
};

// TODO: Move this to a more generic place for all columns
export const createdColumn: Column = {
	id: 'created',
	name: $localize `:Table Created At Column Label@@tableColumnCreatedAtLabel:Created At`,
	path: 'created',
	type: 'date',
};

export const tableCollectionTemplate: TableCollectionTemplate = {
	id: 'table',
	slug: 'table',
	name: 'Table',
	settings: {
		defaultLimit: 5,
		limitOptions: [5, 10, 25],
		columns: [nameColumn, createdColumn],
		activeColumns: [nameColumn, createdColumn],
		filterSidebar: false
	}
}
